export function initCollapseItem() {
	const collapseItems = document.querySelectorAll('.wpcore-collapse');
	collapseItems.forEach((item) => {
		const header = item.querySelector('.wpcore-collapse-header');
		header.addEventListener('click', () => {
			item.classList.toggle('active');
			item.querySelector('.wpcore-collapse-content').classList.toggle('hidden');
		});
	});
}
